module.exports = __webpack_public_path__ + "static/media/logout-icon.c2d124ad.svg";